var map = {
	"./Article": [
		42231,
		1450,
		3015,
		2538
	],
	"./Article.tsx": [
		42231,
		1450,
		3015,
		2538
	],
	"./KategorieA": [
		90741,
		1450,
		3015,
		7530
	],
	"./KategorieA.tsx": [
		90741,
		1450,
		3015,
		7530
	],
	"./KategorieB": [
		53152,
		1450,
		3015,
		2813
	],
	"./KategorieB.tsx": [
		53152,
		1450,
		3015,
		2813
	],
	"./WissenArticlePage": [
		72674,
		1450,
		1634
	],
	"./WissenArticlePage.tsx": [
		72674,
		1450,
		1634
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 17029;
module.exports = webpackAsyncContext;